import { sessionCache } from './cache-manager';

class FeatureDetection {

    setCachedFeature(name, value) {

        sessionCache.set(name, value);

    }

    getCachedFeature(name) {

        sessionCache.get(name);

    }

    /**
     *
     * @desc Instantiates a video tag into the document and tries to start video playback.
     * @returns { Boolean }
     *
     */
    testAutoPlay(muted) {

        const cacheKey = `autoplay-${ muted ? 'muted' : 'unmuted' }`;
        const cachedValue = this.getCachedFeature(cacheKey);

        if(cachedValue) {

            return cachedValue;

        }

        const id = new Date().getTime();
        const style = [
            "position: absolute",
            "left: 0",
            "bottom: 0",
            "width: 1px",
            "height: 1px",
        ].join(";");

        const videoEl = document.createElement('video');
        videoEl.setAttribute('id', `autoPlayVideoPlayerTest_${id}`);
        videoEl.setAttribute('src', 'https://www.mlbstatic.com/mlb.com/mlbtv/video/autoplay-test.mp4');
        videoEl.setAttribute('style', style);
        videoEl.setAttribute('crossOrigin', 'anonymous');
        videoEl.controls = false;
        videoEl.autoplay = false;
        videoEl.loop = false;
        videoEl.muted = muted;
        videoEl.playsinline = true;

        document.body.appendChild(videoEl);

        videoEl.volume = muted ? 0 : 0.1;

        let playbackPromise;

        /**
         * IE & Edge don't have the same behavior
         * Good browsers will reject the promise, MS ones will throw an error
         */
        try {

            playbackPromise = videoEl.play().then(() => true);

        } catch(e) {

            /** We're catching for IE & Edge, we'll assume they're good to go */
            playbackPromise = Promise.resolve(true);
            this.removeChildNode(videoEl);

        }

        return playbackPromise
            .then((hasPassed = true) => {

                this.removeChildNode(videoEl);
                this.setCachedFeature(cacheKey, hasPassed);
                return Promise.resolve(hasPassed);

            })
            .catch(() => {

                this.removeChildNode(videoEl);
                return false;

            });

    }

    removeChildNode(childNode) {

        const parentNode = childNode.parentNode;
        if (parentNode) {

            parentNode.removeChild(childNode);

        }

    }

    /**
     *
     * Utility function to check if the device supports autoplay in HTML5 videos
     * @returns { Boolean }
     *
     */
    testHTML5Autoplay() {

        return Promise.all([
            this.testAutoPlay(false), /** Test unmuted autoplay video */
            this.testAutoPlay(true), /** Test muted autoplay video */
        ]).then(function formatResponse([
            regular,
            muted,
        ]) {

            return {
                regular,
                muted,
            };

        });

    }

}

export default new FeatureDetection();
